///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbNumericInputBaseComponent } from './../numeric-input.base.component';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'kb-currency-text-box',
    templateUrl: './currency-text-box.component.html',
})
export class KbCurrencyTextBoxComponent extends KbNumericInputBaseComponent {
    @ViewChild('currencyInput')
    public currencyInput: NumericTextBoxComponent;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/currency-text-box/currency-text-box.component.ts